import { Decimal } from "@syla/shared/decimal";
import {
  parseOptional,
  parseDate,
  parseDecimal,
} from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { TaxOutcome } from "@syla/shared/types/models/TaxOutcomeBase";
import {
  TransactionEvent,
  Wallet,
  Ledger,
} from "@syla/shared/types/responses/TransactionEvent";
import { parseDataSource } from "../../helper/wallet/parseDataSource";

export function parseTransactionResponseItem(
  transaction: TransportType<TransactionEvent>,
): TransactionEvent {
  return {
    ...transaction,
    date: new Date(transaction.date),
    ledgers: transaction.ledgers.map((l) => parseLedger(l)),
    wallet: parseWalletResponse(transaction.wallet),
    dataSource: parseDataSource(transaction.dataSource),
  };
}

export function parseWalletResponse(wallet: TransportType<Wallet>): Wallet {
  return {
    ...wallet,
    createdAt: parseOptional(wallet.createdAt, parseDate),
    fromDate: parseOptional(wallet.fromDate, parseDate),
    lastSynced: parseOptional(wallet.lastSynced, parseDate),
    lastUploaded: parseOptional(wallet.lastUploaded, parseDate),
    lastFileImportStarted: parseOptional(
      wallet.lastFileImportStarted,
      parseDate,
    ),
    updatedAt: parseOptional(wallet.updatedAt, parseDate),
  };
}

export function parseLedger(ledger: TransportType<Ledger>): Ledger {
  return {
    ...ledger,
    amount: Decimal.from(ledger.amount),
    marketValue: parseOptional(ledger.marketValue, parseDecimal),
    customMarketValue:
      ledger.customMarketValue ?
        {
          ...ledger.customMarketValue,
          value: Decimal.from(ledger.customMarketValue.value),
        }
      : undefined,
    balances:
      ledger.balances ?
        {
          balance: Decimal.from(ledger.balances.balance),
          walletBalance: Decimal.from(ledger.balances.walletBalance),
        }
      : undefined,
    taxOutcomes: ledger.taxOutcomes?.map((taxOutcomes) =>
      parseTaxOutcomes(taxOutcomes),
    ),
  };
}

function parseTaxOutcomes(taxOutcome: TransportType<TaxOutcome>): TaxOutcome {
  return {
    ...taxOutcome,
    gain: parseDecimal(taxOutcome.gain),

    acquisitionDate: parseOptional(taxOutcome.acquisitionDate, parseDate),
    amount: parseOptional(taxOutcome.amount, parseDecimal),
    cost: parseOptional(taxOutcome.cost, parseDecimal),
    proceeds: parseOptional(taxOutcome.proceeds, parseDecimal),
  };
}
